import { Box, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import Observer from '../../../../SolvPatternLibrary/Profilers/Observer';
import useSelectFetchInsuranceDetails from '../../../hooks/useSelectFetchInsuranceDetails';
import { DefaultContainer } from '../CategoryContainers/DefaultContainer';
import HealthChecklistContainer from '../CategoryContainers/HealthChecklistContainer';
import useBlockRenderingForData from '../hooks/useBlockRenderingForData';
import useIterableList from '../hooks/useIterableList';
import useShouldLoadHealthCareChecklist from '../hooks/useShouldLoadHealthCareChecklist';
import injectProps from '../util/injectProps';
import TileList from './TileList';

type Props = {
  category: any;
  userProfile: any;
  insuranceProfile?: any;
  handleObserverChange: (...args: any[]) => any;
  handleDismissTile: (...args: any[]) => any;
};

const CategoryComponent = (props: Props) => {
  const { category, userProfile, handleDismissTile, insuranceProfile, handleObserverChange } =
    props;

  const insuranceDetails = useSelectFetchInsuranceDetails(userProfile.user_profile_id);
  const tiles = useIterableList({ userProfile, category, insuranceDetails });

  const shouldLoadHealthCareCheckList = useShouldLoadHealthCareChecklist(
    category,
    userProfile.birth_date
  );

  const blockRendering = useBlockRenderingForData(
    category.requiredData,
    userProfile,
    insuranceProfile,
    insuranceDetails
  );

  if (blockRendering) return null;

  const title = injectProps(category.title, userProfile, insuranceProfile, insuranceDetails);
  const description = injectProps(
    category.description,
    userProfile,
    insuranceProfile,
    insuranceDetails
  );

  const containerProps =
    // eslint-disable-next-line no-nested-ternary
    category.Container === HealthChecklistContainer
      ? { ...props, category, tiles, shouldLoadHealthCareCheckList }
      : category.Container !== DefaultContainer
      ? { ...props, category, tiles }
      : {};

  const Container = category.Container ? category.Container : DefaultContainer;

  return (
    <Observer handleSawComponent={() => handleObserverChange(title, category.id)} key={title}>
      <Container data-testid={`DiscoverContainer-${category.id}`} key={title} {...containerProps}>
        <Text mb={0.5} px={{ _: 0, sm: 2 }} variant="h3">
          {title}
        </Text>
        <Text mb={1} px={{ _: 0, sm: 2 }}>
          {description}
        </Text>
        <TileList
          category={category}
          // @ts-expect-error ts-migrate(2769) FIXME: Property 'handleDismissTile' does not exist on typ... Remove this comment to see the full error message
          handleDismissTile={handleDismissTile}
          insuranceDetails={insuranceDetails}
          insuranceProfile={insuranceProfile}
          tiles={tiles}
          userProfile={userProfile}
        />
      </Container>
    </Observer>
  );
};

export default CategoryComponent;
